export default __webpack_public_path__ + "static/media/orangesEyesImg.830866fe.png";